import { isDefined } from './is-defined';
export const ROOT_PATH = '#';
export const safeGetValue = (model, propertyPath, defaultValue = undefined) => {
    if (!isDefined(model))
        return defaultValue;
    if (propertyPath === ROOT_PATH) {
        return model;
    }
    const path = Array.isArray(propertyPath) ? propertyPath : propertyPath.split('.');
    return path.reduce((acc, property) => {
        if (!isDefined(acc))
            return defaultValue;
        if (Array.isArray(acc)) {
            const index = parseInt(property, 10);
            if (index >= 0 && index < acc.length) {
                return acc[index];
            }
        }
        if (typeof acc === 'object' && property in acc) {
            return acc[property];
        }
        return defaultValue;
    }, model);
};
//# sourceMappingURL=get-value.js.map